import { XProvider } from '@ant-design/x';
import { theme, Button } from 'antd';
import { ClearOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { clearChat } from '../../app/chatSlice';
import { Chat } from './Chat';
import { SelectedFeaturePanel } from './SelectedFeaturePanel';
import './index.css';

const themeConfig = {
    algorithm: theme.darkAlgorithm,
    token: {
        colorPrimary: '#14d6bc',
        colorInfo: '#14d6bc',
        colorBgContainer: '#262b37',
        colorBgElevated: '#2f3543',
        borderRadius: 8,
        fontFamily: 'Inter, sans-serif',
    },
};

export const AIChat = () => {
    const dispatch = useDispatch();
    const messagesCount = useSelector((s: RootState) => s.chat.messages.length);
    const isPanelOpen = useSelector((s: RootState) => s.chat.isSelectedPanelOpen);
    const hasFeature = useSelector((s: RootState) => s.chat.selectedFeature !== null);
    const showPanel = isPanelOpen && hasFeature;

    return (
        <XProvider theme={themeConfig}>
            <section className="F-AIChat" aria-label="AI Assistant">
                <header className="F-AIChat__header">
                    <div>
                        <div className="F-AIChat__title">
                            <span className="F-AIChat__title-icon">✨</span>
                            AI Assistant
                        </div>
                        <div className="F-AIChat__subtitle">
                            Ask about the annotation results. You can also click on a gene in the IGV browser.
                        </div>
                    </div>
                    <Button
                        type="text"
                        icon={<ClearOutlined />}
                        onClick={() => dispatch(clearChat())}
                        disabled={messagesCount === 0}
                    >
                        Clear chat
                    </Button>
                </header>
                <div className="F-AIChat__body">
                    <div className="F-AIChat__chat-col">
                        <Chat />
                    </div>
                    {showPanel && (
                        <div className="F-AIChat__panel-col">
                            <SelectedFeaturePanel />
                        </div>
                    )}
                </div>
            </section>
        </XProvider>
    );
};
